import {Injectable} from "@angular/core";
import {BehaviorSubject, forkJoin} from "rxjs";
import {map} from "rxjs/operators";
import {Utils} from "@app/utilities/Utils";
import {HttpClient} from "@angular/common/http";
import {CdkDragDrop, moveItemInArray} from "@angular/cdk/drag-drop";
import {AlertsService} from "@app/utilities/alerts.service";
import {ConfirmationDialogService} from "@app/commons/confirmation-dialog/confirmation-dialog.service";

@Injectable({
    providedIn: 'root'
})
export class NewsService{
    news: BehaviorSubject<NewsModal[]> = new BehaviorSubject<NewsModal[]>([]);

    constructor(private http: HttpClient, public snackBar: AlertsService, private confirmservice:ConfirmationDialogService) {
    }
    //used to get and update news
    loadNews(){
        this.http.get(`/api/secured/news/getAllNews`).pipe(map((news: NewsModal[]) => {
            return Utils.orderBy(news, 'orderNum')
        })).subscribe((news: NewsModal[]) => {
            this.news.next(news);
        })
    }
    //used to update the order of news components
    sort(event: CdkDragDrop<any>){
        moveItemInArray(this.news.value, event.previousIndex, event.currentIndex);
        try {
            forkJoin(this.news.value.map((value: NewsModal, index:number) => {
                value.orderNum = index;
                return this.http.post(`/api/secured/portalNews/moveNews`, {
                    id: value.id,
                    title: value.title,
                    index: index
                }).pipe(
                    map((response: {status: string}) => {
                        return {
                            value: value,
                            save: response.status,
                        };
                    }),
                );
                }),
            ).subscribe((res: [{ value: NewsModal; save: string }]) => {
                if (res.every(value => value.save === 'success')) {
                    this.loadNews()
                    this.snackBar.getAlert(`Article Moved`, 'X');
                }
            },
            (error) => {
                this.snackBar.getError('Error: ' + error.status + ' ' + error.statusText,'X')
            }
            );
        }
        catch (e){
            this.snackBar.getError("Error: " + e + ".", 'X');
        }
    }
    //used to add new articles
    add(newArticle: NewsModal) {
        if(!newArticle.catergories){
            newArticle.catergories = "News"
        }
        this.http.post(`/api/secured/portalNews/createNewNews`, newArticle)
            .subscribe(() => {
                    this.loadNews()
                    this.snackBar.getAlert(`Article Added`, 'X');
                },
                (error) => {
                    this.snackBar.getError('Error: ' + error.status + ' ' + error.statusText,'X')
                });
    }
    //used to edit existing articles
    edit(article: NewsModal) {
        this.http.post(`/api/secured/portalNews/editNews`, {
            "id": article.id,
            "catergories": article.catergories,
            "title": article.title,
            "description": article.description,
            "details": article.details
        })
            .subscribe(() => {
                    this.loadNews()
                    this.snackBar.getAlert(`Article Edited`, 'X');
                },
                (error) => {
                    this.snackBar.getError('Error: ' + error.status + ' ' + error.statusText,'X')
                });
    }
    //deletes article
    delete(article: NewsModal) {
        this.confirmservice.openDialog('Warning','Are you sure you want to delete this article?').subscribe(dialogResult=>{
            if(dialogResult){
                this.http.get(`/api/secured/portalNews/deleteNews/${article.id}`, {})
                    .subscribe(() => {
                            this.loadNews()
                            this.snackBar.getAlert(`Article Deleted`, 'X');
                        },
                        (error) => {
                            this.snackBar.getError('Error: ' + error.status + ' ' + error.statusText,'X')
                        });
            }})
    }
}

export class NewsModal {
    id ?: number
    catergories: string = 'news';
    title: string = '';
    header?: string = '';
    description: string = '';
    details: string = '';
    orderNum?: number;

}
